<template>
    <div class="font-14">
        <p class="p-1">
            <span class="has-text-greyText mr-2">{{ hour }}</span>
            <span class="has-text-greyText mr-2">{{ user.name }}</span>
            <span class="has-text-primary has-text-weight-medium">{{
                actionType
            }}</span>
        </p>
        <p v-if="actionComponent" class="pl-2 ml-2">
            <component :is="actionComponent" :action="action" />
        </p>
    </div>
</template>

<script>
import TextAction from "./actions-types/TextActionItem";
import FileAction from "./actions-types/FileActionItem";
import PhotoAction from "./actions-types/PhotoActionItem";
import DateAction from "./actions-types/DateActionItem";
import SignAction from "./actions-types/SignActionItem";
import GetSurveyAction from "./actions-types/GetSurveyActionItem";

export default {
    name: "action-item",
    props: {
        action: {
            type: Object,
            required: true,
        },
    },
    computed: {
        actionComponent() {
            switch (this.action.type) {
                case "text":
                    return TextAction;
                case "file":
                    return FileAction;
                case "photo":
                    return PhotoAction;
                case "date":
                    return DateAction;
                case "sign":
                    return SignAction;
                case "get-survey":
                    return GetSurveyAction;
            }
            return null;
        },
        actionType() {
            switch (this.action.type) {
                case "text":
                    return "Solicitud de texto";
                case "file":
                    return "Solicitud de fichero";
                case "photo":
                    return "Realización de foto";
                case "sign":
                    return "Firma de documento";
                case "get-survey":
                    return "Obtener datos de un Smartform";
            }
            return null;
        },
        state() {
            switch (this.action.state) {
                case 0:
                    return "PENDIENTE";
                case 1:
                    return "COMPLETADA";
            }
            return "";
        },
        title() {
            return this.action.title;
        },
        type() {
            return this.action.type.toUpperCase();
        },
        user() {
            return this.action.user;
        },
        date() {
            if (this.action.date === undefined) {
                return "";
            }
            let date = this.action.date;
            return `${date.toLocaleTimeString()} ${date.toLocaleDateString()}`;
        },
        hour() {
            let date = this.date;
            if (date === "") {
                return "";
            }
            return date.split(" ")[0];
        },
    },
};
</script>

<style lang="scss" scoped>
.is-dark-blue {
    background: #5489ce;
    color: white;
}
</style>